var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.574 13.281q-1.818.001-1.816-1.834V2.56c0-1.22.61-1.84 1.816-1.84h2.783c.657 0 1.026.1 1.471.556l3.229 3.288c.468.48.556.808.556 1.564v5.32c0 1.219-.603 1.834-1.816 1.834zm.041-.943H8.75c.61 0 .92-.322.92-.908V6.168H6.33c-.732 0-1.101-.363-1.101-1.102V1.662H2.62c-.61 0-.92.334-.92.914v8.854c0 .586.31.908.914.908m3.82-7.055h3.053l-3.375-3.44v3.112c0 .234.088.328.323.328"
  })));
};
export default SvgDocument;